import TagManager from 'react-gtm-module';

// const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;
const GTM_ID = process.env.REACT_APP_CUSTOM_PAGE_GOOGLE_TAG_MANAGER_ID;

export const DataLayerLoginEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'login',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerSignUpEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'sign_up',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerViewPlanListEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'view_item_list',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerViewPlanDetailsEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'view_item',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerAddToCartEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'add_to_cart',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerRemoveFromCartEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'remove_from_cart',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerViewCartEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'view_cart',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerBeginCheckoutEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'begin_checkout',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerPurchaseEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'purchase',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerRenewSubscriptionEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'renew_subscription',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerLogoutEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'logout',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerMCXPurchaseEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'mcx_purchase',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerMCXAddToCartEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'mcx_add_to_cart',
      ...data,
    },
    gtmId: GTM_ID,
  });

export const DataLayerMCXBeginCheckoutEvent = (data) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'mcx_begin_checkout',
      ...data,
    },
    gtmId: GTM_ID,
  });
